import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
export default function Logout() {
    const navigate = useNavigate();
    useEffect(() => {
        localStorage.removeItem("jwt");
        navigate("/login");
    }, [navigate]);
  return null;
}
